import { FormField } from '@domain-group/suit-theme'

import { sortPreferredProviders } from '@hooks/useProviders'

import type { ProviderModel } from '@domain-group/realhub-backend-api-types'

import ProviderTile from './ProviderTile'

interface ProviderSelectorProps {
  callbacks: {
    selectProvider: (provider: ProviderModel) => void,
  },
  providers: ProviderModel[],
}

const ProviderSelector = (props: ProviderSelectorProps) => {
  const {
    callbacks: {
      selectProvider,
    },
    providers,
  } = props

  return (
    <FormField direction="column" label="Select Provider">
      {sortPreferredProviders(providers).map(provider => (
        <ProviderTile
          callbacks={{ selectProvider: () => selectProvider(provider) }}
          key={provider.id}
          provider={provider}
        />
      ))}
    </FormField>
  )
}

export default ProviderSelector
